import * as React from "react";
import { UitkHeading, UitkHeadingProps } from "uitk-react-text";
import { LobTitleProps } from "./typings";
import { Viewport, ViewSmall, ViewMedium } from "@shared-ui/viewport-context";
import { useLocalization } from "@shared-ui/localization-context";
import { observer } from "mobx-react";

export const LobTitle: React.FunctionComponent<LobTitleProps> = observer(({ lobState, customTitle }) => {
  const { formatText } = useLocalization();
  const title = customTitle || formatText(lobState.config.heading.locTitleToken);
  const headingConfig: UitkHeadingProps = { tag: "h1", size: 3 };
  const heading = <UitkHeading {...headingConfig}>{title}</UitkHeading>;

  if (lobState.config.heading.hideLobTitle) {
    return null;
  }

  if (lobState.config.heading.differentiatedTitles) {
    return (
      <Viewport>
        <ViewMedium>
          <div className="uitk-type-display-700">{formatText(lobState.config.heading.locTitleDesktopTextToken)}</div>
        </ViewMedium>
        <ViewSmall>{heading}</ViewSmall>
      </Viewport>
    );
  }

  return heading;
});
